<template>
  <div>
    <carousel :perPage="1" on-slide-changed="slideChange($index)">
      <slide>
        <div class="padding">
          <span class="arch">
            I opened my own book and I write in it. The rhythm of language and cadence felt familiar, felt right.
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Hand.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Writing</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Words, phrases</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Bringing it back</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Cementing a world, between worlds.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Her hands feel cold, chilled skin against paper.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">This space is an interstice, elastic borders and fluid joints, a soft place.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">From here, looking back and forward, I reach out with my fingers, feeling nothing, but recognising the shape of her face.
            </p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">I know her, I know those words and that smile, hear her voice.
            </p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Then a door slams shut in my head.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">In another place she writes.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Documenting a world.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">With words.</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">Her</p>
          </span>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <span class="arch">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p style = "font-size:1.5em">pages.</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'An Attempt'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
